import { isParamEmpty, toThousandFilter } from "./filters";
import interfaceAPI from "./interfaceAPI";

// 返回数值（万元以下两位，万元及以上4位）小数，包含单位
export function numberFormat(number) {
    function strNumSize(tempNum) {
        let stringNum = tempNum.toString();
        let index = stringNum.indexOf(".");
        let newNum = stringNum;
        if (index != -1) {
            newNum = stringNum.substring(0, index);
        }
        return newNum.length;
    }
    let moneyUnits = ["元", "万元", "亿元", "万亿"];
    let dividend = 10000;
    let curentNum = number;
    //转换数字
    let curentUnit = moneyUnits[0];
    //转换单位
    for (let i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i];
        if (strNumSize(curentNum) < 5) {
            break;
        }
        curentNum = curentNum / dividend;
    }
    let m = { num: 0, unit: "" };
    m.num = Number(curentNum).toFixed(2);
    m.unit = curentUnit;
    let result = m.num + ' ' + m.unit;
    return toThousandFilter(result.split('.')[0]) + "." + result.split('.')[1];
}

// 返回对象 { num: 数值, unit: 单位 }
export function unitConvert(num) {
    var moneyUnits = ["元", "万元", "亿元", "万亿"]
    var dividend = 10000;
    var curentNum = num;
    //转换数字
    var curentUnit = moneyUnits[0];
    //转换单位
    for (var i = 0; i < 4; i++) {
        curentUnit = moneyUnits[i]
        if (strNumSize(curentNum) < 5) {
            break;
        }
        curentNum = curentNum / dividend
    }
    var m = { num: 0, unit: "" }
    m.num = Number(curentNum.toFixed(2))
    m.unit = curentUnit;
    return m;
}

// 计算数值长度
export function strNumSize(tempNum) {
    var stringNum = tempNum.toString()
    var index = stringNum.indexOf(".")
    var newNum = stringNum;
    if (index != -1) {
        newNum = stringNum.substring(0, index)
    }
    return newNum.length
}

// 判断当前页数
export function currentPageNumber(total, pageIndex, pageSize) {
    let result = Math.ceil(--total / pageSize);
    return result >= pageIndex ? pageIndex : --pageIndex;
}

export function getYearsToNow() {
    let result = [];
    let smallYears = 2017;
    let date = new Date();
    let nowYears = date.getFullYear();
    let Years = nowYears - smallYears;
    let arrYear = [];
    for (let i = 0; i <= Years; i++) {
        arrYear.push(nowYears--);
    }
    arrYear.forEach(item => {
        result.push(item);
    });
    return result;
}

// 过滤地区树结构
export function areaFormater(children) {
    let result = [];
    if (!isParamEmpty(children)) {
        result = children.map((item) => {
            return {
                id: item.id,
                label: item.regionName,
                value: item.regionCode,
                level: item.regionLevel,
                children: areaFormater(item.children),
            };
        });
    } else {
        result = undefined;
    }
    return result;
}

export function getProviceAll() {
    return interfaceAPI.getRegionAll("089f2a3ae09a81b6bc8f99d126ab5780").then(response => {
        return response.data
    });
}

export function getVerificationCode() {
    return interfaceAPI.verificationCode().then(response => {
        return response
    });
}

export function getRegionTree() {
    return interfaceAPI.regionTree().then(response => {
        let resultData = [];
        resultData = response.data.data.map((element) => {
            return {
                id: element.id,
                label: element.regionName,
                value: element.regionCode,
                level: element.regionLevel,
                children: areaFormater(element.children)
            };
        });
        return resultData;
    });
}

/**
 * 根据id下载文件
 * @param {Object} paramObj
 * @method post
 */
export function downloadFile(file) {
    return interfaceAPI.downLoadFile(file.id).then(response => {
        return response;
    });
}

export function downloadTxt(name, res) {
    var aLink = document.createElement('a');
    aLink.download = name; //设置a标签的下载名字
    aLink.style.display = 'none';
    // 字符内容转变成blob地址
    var blob = new Blob([res]);
    aLink.href = URL.createObjectURL(blob);
    // 触发点击
    document.body.appendChild(aLink);
    aLink.click();
    // 然后移除
    document.body.removeChild(aLink);
}
//正式银行内网
//const fastdfsUrl = "http://59.219.204.222:3000/xcx-pic/";
//const fastdfsUrl = new URL(window.location.href).origin +"/xcx-pic/";
//正式互联网
const fastdfsUrl = "https://www.gsxyd.cn/xcx-pic/";
//const fastdfsUrl = "http://www2.gsxyd.cn/xcx-pic/";
//const fastdfsUrl = "http://172.16.150.41:8084/xcx-pic/";
//const fastdfsUrl = "http://36.142.16.26:10660/xcx-pic/";

export function returnFastDfsUrl(params) {
    // if (Object.prototype.toString.call(params) === '[object Object]') {
    //     return `${fastdfsUrl}/${params.fileGroup}/${params.filePath}`;
    // } else if (Object.prototype.toString.call(params) === '[object String]') {
    //     return `${fastdfsUrl}/${params}`;
    // }
    return `${fastdfsUrl}${params || ''}`
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}



// WEBPACK FOOTER //
// ./src/common.js